import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { getAction } from '@/api/manage';
import moment from 'moment';
export default {
  name: 'CmdCn3020List',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  data: function data() {
    return {
      autoLoadInit: false,
      pagePath: '/online/cn3020',
      pageTitle: '现场机信息',
      devType: '1',
      times: [],
      // 站点列
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      isorter: {
        column: 'data_time',
        order: 'desc'
      },
      factorColumn: {
        dataIndex: 'factorName',
        colName: 'factorName',
        title: '污染物名称',
        align: 'center'
      },
      // 表头
      columns: [{
        title: '时间',
        dataIndex: 'dataTime',
        colName: 'data_time',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'info',
        colName: 'info',
        title: '日志信息',
        align: 'center'
      }]
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];
      this.delayLoadData();

      if (window.sessionStorage.getItem('siteType')) {
        this.getCol(window.sessionStorage.getItem('siteType'));
      }
    },
    $route: function $route(to, from) {
      this.devType = '1';
      this.spliceColumn(this.factorColumn, 1);
      this.loadData();
    }
  },
  created: function created() {
    var _this = this;

    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'week'),
      max: moment().endOf('day')
    };
    this.queryParam.stime = this.limitSelectDate.min.format('YYYY-MM-DD HH:mm:ss');
    this.queryParam.etime = this.limitSelectDate.max.format('YYYY-MM-DD HH:mm:ss');
    this.times = [moment(this.queryParam.stime, 'YYYY-MM-DD HH:mm:ss'), moment(this.queryParam.etime, 'YYYY-MM-DD HH:mm:ss')];
    this.devType = '1';
    this.spliceColumn(this.factorColumn, 1);
    setTimeout(function () {
      _this.$bus.$emit('st', '');
    }, 200);
  },
  computed: {},
  methods: {
    moment: moment,
    dataTypeChange: function dataTypeChange(e) {
      this.devType = e.target.value;

      if (this.devType == 1) {
        this.spliceColumn(this.factorColumn, 1);
      } else {
        this.spliceColumn(this.factorColumn);
      }

      this.loadData();
    },
    // onDateChange: function (value, dateString) {
    //   this.queryParam.stime = dateString[0]
    //   this.queryParam.etime = dateString[1]
    //   this.loadData()
    // },
    onDateTime: function onDateTime(value, dateArray) {
      // console.log(value,dateArray)
      this.queryParam.stime = dateArray[0];
      this.queryParam.stime = dateArray[1];
    },
    // 加载表格
    loadData: function loadData(arg) {
      var _this2 = this;

      if (arg === 1) {
        this.ipagination.current = 1;
      }

      this.queryParam = this.getQueryParams(); //查询条件

      this.queryParam.st = window.localStorage.getItem('treeSt');

      if (this.isReport && this.queryParam.scope != '1') {
        return;
      }

      if (this.isReport) {
        this.queryParam.st = window.sessionStorage.getItem('siteType');
      }

      if (!this.queryParam.st && this.queryParam.scope != '1') {
        this.$message.warning('请选择监测系统类型！');
        return;
      }

      this.loading = true;
      var that = this;
      var ss = this.$route.path.split('/');
      this.type = ss[ss.length - 1];
      this.queryParam.infoType = this.type; // 取路由后面的dictId

      this.queryParam.devType = this.devType;
      getAction(this.pagePath, this.queryParam).then(function (res) {
        if (res.success) {
          that.dataSource = res.result.records;
          that.ipagination.total = res.result.total;

          if (that.queryParam.scope == '1') {
            that.spliceColumn(that.siteColumn);
          } else if (that.queryParam.scope == '2' || that.queryParam.scope == '3' || that.queryParam.scope == '4') {
            that.spliceColumn(that.siteColumn, 1);
          }
        } else {
          _this2.$message.warning('系统异常=>' + res.message);
        }

        _this2.loading = false;
      });
    },
    //添加删除列，idx有值代表插入，无值代表删除
    spliceColumn: function spliceColumn(col, idx) {
      //debugger
      var tempColumn = this.columns.filter(function (item) {
        return item.dataIndex != col.dataIndex;
      }); //不允许存在dataIndex相同的列

      if (idx) {
        //插入索引位置
        if (tempColumn.length == this.columns.length) {
          //数组长度一样，说明不存在列，直接添加
          this.columns.splice(idx, 0, col);
        }
      } else {
        if (tempColumn.length != this.columns.length) {
          //数组长度不一样，说明存在列，需要删除
          this.columns = tempColumn;
        }
      }
    }
  }
};